if (document.querySelectorAll('[data-component="hamburger"]').length > 0) {
    document.addEventListener('DOMContentLoaded', function () {

        const toggle = document.querySelector('[data-toggle="navbar-toggle"]');
        const target = document.querySelector('#navbar-dropdown');
        const expanded = target.getAttribute('aria-expanded');

        toggle.addEventListener('click', function () {
            target.classList.toggle('show');

            if (expanded == 'true') {
                expanded = 'false';
            } else {
                expanded = 'true';
            }

            target.setAttribute('aria-expanded', expanded)
        });
    })
}